(
    function (skyward, $, undefined)
    {
        skyward.easyiep = skyward.easyiep || {};

        var init = function (selector)
        {
            "use strict";

            var pageCheck;

            pageCheck = $(selector).find("#b7bc399a-e0e8-4bc5-ad28-f123b973dd13");

            if (pageCheck.length > 0) {
                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    skyward.easyiep.handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
            else {
                return;
            }
        }

        skyward.easyiep.handleImportTypeCodeChange = function ()
        {
            var specialEdRadioButton = $("#ImportTypeCode_RadioButtonGroup input[type='radio'][value='SE']");
            var fileSelect = $("#fileSelect");
            var chooseFileRadioButton;

            if (specialEdRadioButton.is(":checked")) {
                chooseFileRadioButton = $("#FilePathOptionSpecial_RadioButtonGroup input[type='radio'][value='C']");
            }
            else {
                chooseFileRadioButton = $("#FilePathOption504_RadioButtonGroup input[type='radio'][value='C']");
            }

            if (chooseFileRadioButton.is(":checked")) {
                fileSelect.show();
            }
            else {
                fileSelect.hide();
            }
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);